"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const utils_1 = require("./utils");
const ProviderContact = ({ location, contactType }) => {
    const contactDetails = (0, utils_1.getContactDetails)(location, contactType);
    const contactElem = react_1.default.createElement("span", { itemProp: contactType }, contactDetails);
    return (react_1.default.createElement(react_1.default.Fragment, null, contactDetails && (react_1.default.createElement("li", null,
        react_1.default.createElement(styles_1.LocationInfoItem, null,
            react_1.default.createElement("span", { className: 'contact-label' }, `${contactType}: `),
            contactType === 'phone' ? (react_1.default.createElement(styles_1.LocationPhoneAnchor, { "data-testid": `${contactType}Link`, href: `tel:${contactDetails}` }, contactElem)) : (contactElem))))));
};
exports.default = ProviderContact;
//# sourceMappingURL=provider-contact.js.map